<div class="tab-pane" role="tabpanel" id="plazo">
    <fieldset id="agregar_plazo" class="">
        <div class="step_section">
            <form [formGroup]="form">
                <div class="row" id="row">

                    <div class="col-md-12" id="content">
                        <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                            <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                            <span id="tp_dir_message"></span>
                        </div>
                        <div class="form-horizontal">
                            <div class="form-group" align="left">
                                <div class="col-sm-6">
                                    <label for="plazo" style="padding-top: 15px">Plazo (En caso de Articulos 121,122,123,124 de la LGUC):</label>
                                </div>

                                <div class="col-sm-3" align="left">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Vigencia" id="plazo" name="plazo" formControlName="plazo" (change)="add_plazo()">
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-3" align="left">
                                    <label for="anio" style="padding-top: 15px"><strong>Años</strong></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>


    </fieldset>
</div>
<div class="separator"></div>